<template>
  <AppLayout>
    <div class="col-12 layout-spacing">
      <div class="widget widget-six">
        <ubraniaMenu></ubraniaMenu>
        <div class="widget-heading">
          <div class="row mb-3">
            <div class="col-12 d-flex flex-wrap gap-2">
              <div class="flex-fill d-flex" style="min-width: 300px;">
                <select v-model="selectedDepartament" class="form-select w-100" @change="loadData">
                  <option value="0">WSZYSTKIE DZIAŁY</option>
                  <option v-for="department in departaments" :key="department.id" :value="department.id">
                    {{ department.name }}
                  </option>
                  <option value="-1">POZOSTALI PRACOWNICY</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="widget-content">

          <div class="table-responsive w-100">
            <table class="table table-bordered table-hover text-center">
              <thead>
              <tr>
                <th class="bg-gray-100 text-start">#</th>
                <th class="bg-gray-100 text-start" @click="sortBy('userName')" style="cursor:pointer">
                  Pracownik
                  <span v-if="sortKey === 'userName'"> {{ sortOrder === 'asc' ? '▲' : '▼' }}</span>
                </th>
                <th v-for="g in grupy" :key="g.id" class="bg-gray-100 text-start" style="cursor:pointer"
                    @click="sortBy(g.id)">
                  {{ g.nazwa }}
                  <span v-if="sortKey === g.id"> {{ sortOrder === 'asc' ? '▲' : '▼' }}</span>
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(user, i) in filteredAndSortedUsers" :key="user.userId">
                <td style="width: 15px;">{{ i + 1 }}</td>
                <td class="text-start">{{ user.userName }}</td>
                <td v-for="gr in user.grupy" :key="gr.grupa_id" class="text-center" style="cursor:pointer"
                    @click="openRozmiaryModal(user.userId, gr.grupa_id, gr.rozmiar_id)">{{ gr.rozmiar || '' }}
                </td>
              </tr>
              </tbody>
            </table>
          </div>

          <div v-if="isModalOpen" class="modal fade show" tabindex="-1" style="display: block;">
            <div class="modal-dialog modal-lg">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">Wybierz rozmiar</h5>
                  <button type="button" class="btn-close" @click="closeRozmiaryModal"></button>
                </div>
                <div class="modal-body">
                  <div class="row">
                    <div v-for="roz in rozmiaryArray" :key="roz.id" class="col-3 mb-2">
                      <div class="form-check">
                        <input class="form-check-input" type="radio" :id="'rozmiar-' + roz.id" :value="roz.id"
                               v-model="selectedRozmiary[0]">
                        <label class="form-check-label" style="color: black;" :for="'rozmiar-' + roz.id">{{
                            roz.nazwa
                          }}</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-danger" @click="deleteRozmiar">Usuń rozmiar</button>
                  <button type="button" class="btn btn-secondary" @click="closeRozmiaryModal">Zamknij</button>
                  <button class="btn btn-success" @click="saveRozmiary">Zapisz</button>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import ubraniaMenu from "@/Pages/BHP/parts/ubraniaMenu.vue";
import axios from 'axios';

export default {
  components: {AppLayout, ubraniaMenu},
  props: {
    departaments: Array,
    departamentId: Number,
    rozmiary: Object,
  },
  data() {
    const today = new Date();
    return {
      users: [],
      isModalOpen: false,
      selectedDepartament: this.departamentId ?? 1,

      sortKey: "userName",
      sortOrder: "desc",

      selectedUserId: null,
      selectedField: null,
      selectedRozmiary: [],

    };
  },

  computed: {
    filteredAndSortedUsers() {
      return [...this.users].sort((a, b) => {
        let result = 0;

        if (this.sortKey === 'userName') {
          if (a.userName > b.userName) result = 1;
          if (a.userName < b.userName) result = -1;
        } else {
          // sortKey traktujemy jako grupa_id
          const groupId = parseInt(this.sortKey);
          const aGroup = a.grupy.find(g => g.grupa_id === groupId)?.rozmiar || '';
          const bGroup = b.grupy.find(g => g.grupa_id === groupId)?.rozmiar || '';
          if (aGroup > bGroup) result = 1;
          if (aGroup < bGroup) result = -1;
        }

        return this.sortOrder === 'asc' ? result : -result;
      });
    }
  },
  mounted() {
    if (this.rozmiary) {
      this.rozmiaryArray = Object.entries(this.rozmiary).map(([id, nazwa]) => ({id: parseInt(id), nazwa}));
    }
    this.loadData();
  },
  methods: {
    async deleteRozmiar() {
      try {
        await axios.post(route("bhp.rozmiary.pracownikow.update"), {
          user_id: this.selectedUserId,
          grupa_id: this.selectedGrupaId,
          rozmiar_id: null,
        });

        this.closeRozmiaryModal();
        this.loadData();
        this.showToast('success', 'Sukces', 'Rozmiar został usunięty');
      } catch (error) {
        console.error("Błąd usuwania rozmiaru:", error);
        this.showToast('error', 'Błąd', 'Nie udało się usunąć rozmiaru');
      }
    },
    openRozmiaryModal(userId, grupaId, currentValue) {
      this.selectedUserId = userId;
      this.selectedGrupaId = grupaId;
      this.selectedRozmiary = currentValue ? [parseInt(currentValue)] : [];
      this.isModalOpen = true;
    },

    closeRozmiaryModal() {
      this.isModalOpen = false;
      this.selectedUserId = null;
      this.selectedField = null;
      this.selectedRozmiary = [];
    },

    async saveRozmiary() {
      const rozmiarId = this.selectedRozmiary.length
          ? parseInt(this.selectedRozmiary[0])
          : null;

      try {
        await axios.post(route("bhp.rozmiary.pracownikow.update"), {
          user_id: this.selectedUserId,
          grupa_id: this.selectedGrupaId,
          rozmiar_id: rozmiarId,
        });

        this.closeRozmiaryModal();
        this.loadData();
      } catch (error) {
        console.error("Błąd zapisu rozmiaru:", error);
        this.showToast('error', 'Błąd', 'Nie udało się zapisać rozmiaru');
      }
    },

    async loadData() {
      try {
        const response = await axios.get(
            route("bhp.rozmiary.pracownikow.dane"),
            {params: {departament: this.selectedDepartament}}
        );
        this.users = response.data.users || [];
        this.grupy = response.data.grupy || [];
        this.rozmiaryArray = Object.entries(response.data.rozmiary || {}).map(([id, nazwa]) => ({
          id: parseInt(id),
          nazwa
        }));
      } catch (error) {
        console.error("Błąd ładowania danych:", error);
      }
    },
    sortBy(key) {
      if (this.sortKey === key) {
        this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
      } else {
        this.sortKey = key;
        this.sortOrder = "asc";
      }
    },
    showToast(icon, title, message) {
      Toast.fire({
        position: 'top-end',
        toast: true,
        icon: icon,
        title: title,
        html: message,
        showClass: {popup: 'animate__animated animate__fadeInDown'},
        hideClass: {popup: 'animate__animated animate__fadeOutUp'},
        timer: 1500,
        timerProgressBar: true,
        showConfirmButton: false,
        showCloseButton: true
      });
    }
  },
};
</script>

<style scoped>
table th,
table td {
  min-width: 50px;
  height: 32px;
  text-align: center;
}
.bg-gray-100 {
  background-color: #f5f5f5;
  color: black;
}
.text-start {
  text-align: left;
}

.table tbody tr:nth-child(even) td:not([style*="background-color"]) {
  background-color: #f9f9f9 !important;
}

.table tbody tr:nth-child(odd) td:not([style*="background-color"]) {
  background-color: #ffffff !important;
}

/* hover nadal działa, ale tylko na niekolorowanych komórkach */
.table tbody tr:hover td:not([style*="background-color"]) {
  background-color: #eaeaea !important;
}
</style>
